// src/data/institutes.js
// Shared list of institutes with metadata for dropdowns and auto-fill

export const INSTITUTES = [
  {
    name: 'Alphonsa College',
    pincode: '686574',
    phone: '0482-2212447',
    address: 'Alphonsa College, Pala',
  },
  {
    name: 'Amal Jyothi College Of Engineering',
    pincode: '686518',
    phone: '04828-251661',
    address: 'Amal Jyothi College Of Engineering, Kanjirapally',
  },
  {
    name: 'Assumption College',
    pincode: '686101',
    phone: '0481-2420109',
    address: 'Assumption College, Changanacherry',
  },
  {
    name: 'Athurasrammam N S S Homeo College',
    pincode: '686532',
    phone: '0481-2430362',
    address: 'Sachivothamapuram P O, Kottayam',
  },
  {
    name: 'B.C.M. College for Women',
    pincode: '686001',
    phone: '0481-2562171',
    address: 'Kottayam',
  },
  { name: 'Baselius College', pincode: '686001', phone: '0481-2563918', address: 'Kottayam' },
  {
    name: 'Bishop Kurialacherry College for Women',
    pincode: '686561',
    phone: '0481-2597384',
    address: 'Amalagiri',
  },
  {
    name: 'Bishop Vayalil Memorial Holy Cross College',
    pincode: '686584',
    phone: '0482-2267520',
    address: 'Cherpunkal',
  },
  { name: 'CMS College', pincode: '686001', phone: '0481-2566002', address: 'Kottayam' },
  {
    name: 'College of Applied Science (IHRD)',
    pincode: '686612',
    phone: '04829-264177',
    address: 'Njeezhoor P. O., Kaduthuruthy',
  },
  {
    name: 'College of Applied Science (IHRD), Puthuppally',
    pincode: '686019',
    phone: '0481-2351631',
    address: 'Puthuppally, Kottayam',
  },
  {
    name: 'College of Engineering, Kidangoor',
    pincode: '686583',
    phone: '04822-256056',
    address: 'Kidangoor, Kottayam',
  },
  { name: 'Deva Matha College', pincode: '686633', phone: '0482-2230233', address: 'Kuravilangad' },
  {
    name: 'Devaswom Board College',
    pincode: '686605',
    phone: '04829-236136',
    address: 'Thalayolaparambu',
  },
  {
    name: 'Ettumanoorappan College',
    pincode: '686631',
    phone: '0481-2536978',
    address: 'Ettumanoor',
  },
  {
    name: 'Government College, Kottayam',
    pincode: '686013',
    phone: '0481-2363116',
    address: 'Nattakom P O, Kottayam',
  },
  {
    name: 'Government College of Nursing',
    pincode: '686008',
    phone: '0481-2598469',
    address: 'Medical College Campus, Gandhinagar, Kottayam',
  },
  {
    name: 'Government Dental College',
    pincode: '686008',
    phone: '0481-2594046',
    address: 'Medical College Campus, Kottayam',
  },
  {
    name: 'Government Medical College, Kottayam',
    pincode: '686008',
    phone: '0481-2731050',
    address: 'Gandhinagar, Kottayam',
  },
  {
    name: 'Indian Institute of Information Technology',
    pincode: '686635',
    phone: '04822-202100',
    address: 'Chakkampuzha Rd, Valavoor, Kottayam',
  },
  {
    name: 'Indian Institute of Mass Communication (Southern Regional Campus)',
    pincode: '686501',
    phone: '0481-2730161',
    address: '8th Mile, Velloor, KK Road, Pampady, Kottayam',
  },
  {
    name: 'Kristu Jyoti College of Management and Technology',
    pincode: '686104',
    phone: '0481-2720696',
    address: 'Chetipuzha, Kurisummoodu P.O., Changanacherry',
  },
  {
    name: 'Kuriakose Elias College',
    pincode: '686561',
    phone: '0481-2597374',
    address: 'Mannanam, Kottayam',
  },
  {
    name: 'Kuriakose Gregorios College',
    pincode: '686521',
    phone: '0481-2505212',
    address: 'Pampady',
  },
  {
    name: 'MAHATHMA GANDHI UNIVERSITY',
    pincode: '686560',
    phone: '91-481-2731009',
    address: 'Priyadarsini Hills P.O, Kottayam',
  },
  {
    name: 'Mangalam College of Education',
    pincode: '686631',
    phone: '9895010120',
    address: 'Ettumanoor',
  },
  {
    name: 'Mount Carmel College of Teacher Education',
    pincode: '686002',
    phone: '0481-2573120',
    address: 'Kanjikuzhy, Kottayam',
  },
  {
    name: 'N.S.S. Training College',
    pincode: '686102',
    phone: '0481-2420481',
    address: 'Changanacherry',
  },
  { name: 'NSS Hindu College', pincode: '686102', phone: '0481-2420090', address: 'Changanassery' },
  {
    name: 'Rajiv Gandhi Institute of Technology',
    pincode: '686501',
    phone: '0481-2508453',
    address: 'Velloor, Pampady, Kottayam',
  },
  {
    name: 'SAINTGITS College of Engineering',
    pincode: '686532',
    phone: '0481-2436169',
    address: 'Kottayam',
  },
  {
    name: 'Sree Vidyadhi Raja N S S College',
    pincode: '686505',
    phone: '0481-2456227',
    address: 'Vazhoor, Kerala',
  },
  {
    name: 'St. Berchmans College',
    pincode: '686101',
    phone: '0481-2420025',
    address: 'Changanassery',
  },
  {
    name: 'St. Dominic’s College',
    pincode: '686512',
    phone: '04828-234340',
    address: 'Kanjirappally',
  },
  {
    name: 'St. Johns The Baptist’s College of Education',
    pincode: '686542',
    phone: '0481-2485048',
    address: 'Nedumkunnam',
  },
  {
    name: 'St. Joseph College of Engineering and Technology',
    pincode: '686579',
    phone: '04822-239700',
    address: 'Choondacherry P.O, Palai, Kottayam',
  },
  {
    name: 'St. Joseph’s Training College',
    pincode: '686561',
    phone: '0481-2597347',
    address: 'Kottayam',
  },
  { name: 'St. Mary’s College', pincode: '686019', phone: '0481-2374483', address: 'Manarcaud' },
  { name: 'St. Stephen’s College', pincode: '686634', phone: '0482-2240127', address: 'Uzhavoor' },
  { name: 'St. Thomas College, Pala', pincode: '686574', phone: '04822-212317', address: 'Pala' },
  {
    name: 'St. Thomas Training College',
    pincode: '686575',
    phone: '0482-2216537',
    address: 'Pala',
  },
  { name: 'St. Xavier’s College, Vaikom', pincode: '686141', phone: '', address: 'Vaikom' },
].sort((a, b) => a.name.localeCompare(b.name));

export const INSTITUTE_BY_NAME = new Map(INSTITUTES.map((i) => [i.name, i]));
